import yallaPng from "../../assets/img/yallaLodoLg.png";

const headerBanners = [
    {
        id: "hb_1",
        h1: "يلا لودو",
        h2: "قطع ذهبية والماس",
        p: "تظبط لعبك وتظبط حسابك",
        img: yallaPng,
        link: "#"
    },
    {
        id: "hb_2",
        h1: "يلا لودو",
        h2: "قطع ذهبية والماس",
        p: "تظبط لعبك وتظبط حسابك",
        img: yallaPng,
        link: ""
    },
    {
        id: "hb_3",
        h1: "يلا لودو",
        h2: "قطع ذهبية والماس",
        p: "تظبط لعبك وتظبط حسابك",
        img: yallaPng,
        link: "#"
    }
];
export default headerBanners;
